import { render, staticRenderFns } from "./CustomTreeItems.vue?vue&type=template&id=194ce218"
import script from "./CustomTreeItems.js?vue&type=script&lang=js&external"
export * from "./CustomTreeItems.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports